<template>
  <div>
    <strong v-if="location === 'general-info'">{{
      trans("examination.testPatientLabel")
    }}</strong>

    <div class="text-muted">
      <i class="fas fa-user-check" :title="trans('general.testPatientTitle')" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: String,
  },
};
</script>
